<div class = "body">
    <div class ="text1">
        <h1>All the Dessert Receipes I have Tried 💗</h1>
        <h2><i>Click each photos to see the process of making these desserts!</i></h2>
    </div>

    <div class="grid-container">
        
        <div>
            <img class='grid-item grid-item-5' src='assets/bake-img/mango-nuomici.JPG' alt=''>
            <p>"Mango Nuomici - Almost cried while making this, so hard to put mango inside of those memorialis hirta"</p>
        </div>
        <div>
            <img class='grid-item grid-item-6' src='assets/bake-img/souffle.jpg' alt=''>
            <p>"Souffle! Should have put more sugar"</p>
        </div>
        <div>
            <img class='grid-item grid-item-7' src='assets/bake-img/berry-yogurt-cake.jpg' alt=''>
            <p>"Berry Yogurt Cake~"</p>
        </div>
        
        <div>
            <img class='grid-item grid-item-9' src='assets/bake-img/cotton-cheese-cake.JPG' alt=''>
            <p>"Cotton Cheese Cake - my dad's favorite cake lol, and it is so easy to make</p>
        </div>
        <div>
            <img class='grid-item grid-item-12' src='assets/bake-img/cheesecake.jpg' alt=''>
            <p>"Cheesecake~"</p>
        </div>
        
        <div>
            <img class='grid-item grid-item-14' src='assets/bake-img/salmon-crepe.JPG' alt=''>
            <p>"Salmon Crepe - Aaaaaamazingggg who said crepe can only be sweet"</p>
        </div>
        <div>
            <img class='grid-item grid-item-15' src='assets/bake-img/glutinous-rice-balls.JPG' alt=''>
            <p>"Glutinous Rice Meatballs - sooo hard to steam it through"</p>
        </div>
        <div>
            <img class='grid-item grid-item-16' src='assets/bake-img/marshmallow-chip.JPG' alt=''>
            <p>"Marshmallow w/ Chips!"</p>
        </div>
    </div>
</div>